import { t } from 'i18next'

import { Render } from '@/shared/components/render-if'

type TCardInfoPercentualProps = {
  resumoDistribuicao: {
    completo: boolean
    excesso?: boolean
    diferenca?: number
    total: number
  }
}

export default function CardInfoPercentual({ resumoDistribuicao }: Readonly<TCardInfoPercentualProps>) {
  const text = () => {
    if (resumoDistribuicao.completo) return t('proposta:detalhes_proposta.participacao_comprador.distribuicao_completa')
    if (resumoDistribuicao.excesso) return t('proposta:detalhes_proposta.participacao_comprador.excesso_de')
    return t('proposta:detalhes_proposta.participacao_comprador.faltam')
  }
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-1">
        <div className="flex flex-col gap-2 sm:flex-row">
          <p className="font-medium text-neutral-600">
            {t('proposta:detalhes_proposta.participacao_comprador.soma_participacoes')}
          </p>
          <p className="font-medium text-neutral-800">{text()}</p>
        </div>
        <Render.If condition={!resumoDistribuicao.completo}>
          {() => <p className="text-neutral-800">{resumoDistribuicao.diferenca}%</p>}
        </Render.If>
      </div>
    </div>
  )
}
